export const API_URL = "https://api.bibeet.com"
export const SOCKET_URL = "https://socket.bibeet.com/"
export const PRAGMATIC_URL = "https://cp.bibeet.com"
export const PGSOFT_URL = "https://spgf.bibeet.com"
export const AMATIC_URL = "https://spamatic.bibeet.com"